import { gql } from 'apollo-boost'

const UPDATE_SCRAPING_SESSION_TEMPLATE = gql`
  mutation updateScrapingSessionTemplate(
    $id: ID!
    $alias: String
    $description: String
    $tagGroupIds: [ID!]!
  ) {
    updateScrapingSessionTemplate(
      id: $id
      alias: $alias
      description: $description
      tagGroupIds: $tagGroupIds
    )
  }
`

export default UPDATE_SCRAPING_SESSION_TEMPLATE
